import { t } from '@unistocks/shared/localization/index.ts';
import { Stack } from 'expo-router';

export default function ExternalAccountsLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: 'transparent' }
      }}
    >
      <Stack.Screen name="index" options={{ title: t('::ExternalAccounts') }} />
      <Stack.Screen name="add-account" options={{ title: t('::ExternalAccounts:AddAccount') }} />
      <Stack.Screen name="import" options={{ title: t('::Menu:Import') }} />
    </Stack>
  );
}
